// ganttLabelGenerators.js

import moment from 'moment';

function formatDuration(startTime, endTime) {
    const start = moment(startTime);
    const end = moment(endTime);
    const duration = moment.duration(end.diff(start));

    const hours = Math.floor(duration.asHours());
    const minutes = Math.floor(duration.asMinutes()) - hours * 60;

    return `${hours}h ${minutes}m`;
}

const generateAvailabilityItemLabel = (availability) => {
    const duration = formatDuration(availability.time.start, availability.time.end);
    const startTimeFormatted = moment(availability.time.start).format('hh:mm A');
    const endTimeFormatted = moment(availability.time.end).format('hh:mm A');

    return `${startTimeFormatted} - ${endTimeFormatted} (${duration})`;
}

const generateScheduleItemLabel = (schedules, forClassroom = false) => {
    const scheduleCount = schedules.length;

    if (scheduleCount > 1) {
        return forClassroom ? `${scheduleCount} teachers`:`${scheduleCount} schedules`;
    } else {
        const schedule = schedules[0];
        if(forClassroom){
            return `${schedule.teacherFirstName} ${schedule.teacherLastName}`;
        }
        else{
            const duration = formatDuration(schedule.startTime, schedule.endTime);
            const startTimeFormatted = moment(schedule.startTime).format('hh:mm A');
            const endTimeFormatted = moment(schedule.endTime).format('hh:mm A');
    
            return `${startTimeFormatted} - ${endTimeFormatted} (${duration})`;
        }
    }
}

const generateStudentScheduleItemLabel = (schedules) => {
    const scheduleCount = schedules.length;
    if (scheduleCount > 3) {
        return `${scheduleCount} students`;
    } else if (scheduleCount > 1 && scheduleCount <= 3) {
        return schedules
            .map(schedule => {
                return schedule.studentFirstName;
            })
            .join(', ');
    } else if (scheduleCount === 1) {
        return `${schedules[0].studentFirstName} ${schedules[0].studentLastName}`;
    }
    return '';
};



export { generateScheduleItemLabel, generateStudentScheduleItemLabel, generateAvailabilityItemLabel };
